import { useState } from "react"
import { Col, Divider, Row, Segmented } from "antd"
import PageHeader from "../../../components/Elements/PageHeader"
import { ArrowDownOutlined, BgColorsOutlined, HomeOutlined, RedoOutlined } from "@ant-design/icons"
import IncomingTable from "./Incoming/IncomingTable"
import InventoryTable from "./Inventory/InventoryTable"
import WarehouseSnapshotView from "./Snapshot/WarehouseSnapshotView"
import { useAuthContext } from "../../../hooks/useAuthContext"
import WarehouseAwaitingDocs from "./AwaitingDocs/WarehouseAwaitingDocs"

export default function Warehouse() {
  const [tab, setTab] = useState("Incoming")
  const { devSpecialist } = useAuthContext()

  // Build options based on whether devSpecialist is true
  const options = devSpecialist
    ? [
        { label: "Incoming", value: "Incoming", icon: <ArrowDownOutlined /> },
        { label: "Warehouse", value: "devWarehouse", icon: <HomeOutlined /> },
        { label: "Products", value: "devWarehouseProducts", icon: <HomeOutlined /> },
      ]
    : [
        { label: "Incoming", value: "Incoming", icon: <ArrowDownOutlined /> },
        { label: "Warehouse", value: "Warehouse", icon: <HomeOutlined /> },
        { label: "Viva", value: "Viva", icon: <BgColorsOutlined /> },
        { label: "Arsoma", value: "Arsoma", icon: <BgColorsOutlined /> },
        { label: "Winder", value: "Winder", icon: <RedoOutlined /> },
        { label: "Warehouse", value: "devWarehouse", icon: <HomeOutlined /> },
      ]

  return (
    <div style={{ padding: 15 }}>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <PageHeader text="Warehouse" icon={<HomeOutlined />} />
        </Col>

        <Col span={24}>
          <Segmented
            size="large"
            shape="round"
            value={tab}
            onChange={(value) => setTab(value)}
            options={options}
          />
          <Divider style={{ margin: "12px 0" }} />
        </Col>

        <Col span={24}>
          {tab === "Incoming" && <IncomingTable />}
          {!devSpecialist && tab === "Warehouse" && <InventoryTable location="Warehouse" />}
          {!devSpecialist && tab === "Viva" && <InventoryTable location="Viva" />}
          {!devSpecialist && tab === "Arsoma" && <InventoryTable location="Arsoma" />}
          {!devSpecialist && tab === "Winder" && <InventoryTable location="Winder" />}
          {tab === "devWarehouse" && <WarehouseSnapshotView />}
          {tab === "devWarehouseProducts" && <WarehouseAwaitingDocs />}
        </Col>
      </Row>
    </div>
  )
}
